import { getUser } from './auth';

export const hasPermission = (permission: string): boolean => {
  const user = getUser();
  // Check for user existence
  if (!user) {
    return false;
  }

  // Handle both snake_case (standard Laravel JSON) and camelCase (JS convention)
  const permissions = (user.role_permission || user.rolePermission) as Record<string, any>;
  
  if (!permissions) {
    return false;
  }

  // Admin Super-Access: Always allow if role is Admin or Super Admin (case-insensitive)
  const roleName = permissions.role_name;
  if (roleName && ['admin', 'super admin'].includes(String(roleName).trim().toLowerCase())) {
    return true;
  }
  // Check if the permission key exists and is truthy (1 or true)
  return !!permissions[permission];
};
